
/* styles */
require("!!../../extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../vue-loader/lib/style-compiler/index?{\"id\":\"data-v-54852400\",\"scoped\":false,\"hasInlineConfig\":true}!./annotationLayer.css")

var Component = require("!../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../vux-loader/src/script-loader.js!../../vue-loader/lib/selector?type=script&index=0!./vuePdfNoSss.vue"),
  /* template */
  null,
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue-pdf/src/vuePdfNoSss.vue
// module id = 562
// module chunks = 90